import loadableVisibility from 'react-loadable-visibility/loadable-components';


const Loadable = loadableVisibility(
  () => import(/* webpackChunkName: "header.login" */'./Loadable'),
);

export default Loadable;
